import { Box, Typography, Card, TextField, Button, CardContent, Alert, LinearProgress } from '@mui/material'
import React, { useState } from 'react'
import logo from "./IIAL.jpg"
import { auth } from '../../firebase'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { Navigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { selectUser, setUser } from '../../features/auth/authSlice'
import useMediaQuery from '@mui/material/useMediaQuery'

export default function Login() {
	// username
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [alert, setAlert] = useState(false);
	const [loading, setLoading] = useState(false);

	const user = useSelector(selectUser);
	const dispatch = useDispatch();

	const onUsernameChange = e => setUsername(e.target.value);
	const onPasswordChange = e => setPassword(e.target.value);

	const onClickSubmitButton = e => {
		e.preventDefault()
		setLoading(true)
		signInWithEmailAndPassword(auth, username, password).then(
			response => {
				dispatch(setUser({
					user: { uid: auth.currentUser.uid, email: auth.currentUser.email }
				}))
				console.log("sign in successfully")
				setLoading(false)
			}
		).catch(
			err => {
				console.log(err);
				setLoading(false)
				setAlert(true)
			}
		)
	}

	// // user test function 
	// const userTest = () => {
	// 	// if (auth.currentUser)
	// 	//	 console.log("User active");
	// 	// else 
	// 	//	 console.log("User inactive");
	// 	console.log(auth.currentUser);
	// 	console.log(user);
	// }

	// // test function sign out
	// const onClickSignOut = () => {
	// 	signOut(auth).then(
	// 		response => {
	// 			dispatch(setUser({
	// 				user: null
	// 			}))
	// 			console.log("user signed out successfully")
	// 		}
	// 	).catch(
	// 		err => console.log(err)
	// 	)
	// }

	let displayDevice = useMediaQuery('(min-width:600px)');

	let flexDir = displayDevice?"row":"column";

	if (user)
		return <Navigate to="/home" />
	else {
		return (
			<div>
				 <Box sx={{ display: "flex", flexDirection: flexDir, justifyContent: "center", alignItems: "center", width: "100%", height: "100vh" }}>
					<Box>
						<img src={logo} alt="ILALC Logo" width="90%" height={"auto"} />
					</Box>
					<Box sx={{ flexGrow: 1, padding: "10px", minWidth: "30%", margin: "10px" }}>
						<Card sx={{ display: "flex", flexDirection: 'column', alignItems: 'center'}}>
							<CardContent>
								<Typography component="h1" variant="h5" align='center'>
									Log In
								</Typography>
								{alert ? <Alert severity="error" onClose={() => { setAlert(false) }}>Wrong username or password</Alert> : <></>}
								<form onSubmit={onClickSubmitButton} >
									<TextField
										margin="normal"
										required
										fullWidth
										id="username"
										label="Username"
										name="username"
										autoComplete="Email"
										autoFocus
										defaultValue={""}
										onChange={onUsernameChange}
									/>

									<TextField
										margin="normal"
										required
										fullWidth
										name="password"
										label="Password"
										type="password"
										id="password"
										autoComplete="current-password"
										defaultValue={""}
										onChange={onPasswordChange}
									/>

									{loading ? <LinearProgress style={{height: "10px", borderRadius: "5px"}} /> : <Button
										type="submit"
										fullWidth
										variant="contained"
										sx={{ mt: 3, mb: 2 }}
									>
										Login
									</Button>}
								</form>
							</CardContent>
						</Card>
					</Box>
				</Box>
			</div>
		);
	}
}
